export const localise = (currentLang: string, name: string) => {
    const match = name.match(/^(.+?)\s+\((.+?)\)$/);
    if (!match) return name; // fallback to full name if format doesn't match

    const [_, enName, asName] = match;
    return currentLang === 'as' ? asName : enName;
};